import React from 'react'
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import AppButton from "../../ui/AppButton";
import {Link} from "react-router-dom";
import AppInputText from "../../ui/AppInputText";
import AppInputTel from "../../ui/AppInputTel";
import AppInputCel from "../../ui/AppInputCel";
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import Colors from "../../config/colors";
import Avatar from "@material-ui/core/Avatar";
import AppInputPasswordView from "../../ui/AppInputPasswordView";
import AppInputNumber from "../../ui/AppInputNumber";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Alert from "@material-ui/lab/Alert";
import {Checkbox, FormControlLabel} from "@material-ui/core";
import AlertPrivacyPolicy from "./AlertPrivacyPolicy";
import AlertDataTreatment from "./AlertDataTreatment";

class SignupForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            openModal: false,
            openModalTD: false,
        };
    }

    handleOpenModal = () => {
        this.setState({openModal: true})
    }

    handleCloseModal = () => {
        this.setState({openModal: false})
    }

    handleOpenModalTD = () => {
        this.setState({openModalTD: true})
    }

    handleCloseModalTD = () => {
        this.setState({openModalTD: false})
    }

    render() {

        const {
            documentoTipoID,
            terceroDocumento,
            terceroNombre1,
            terceroNombre2,
            terceroApellido1,
            terceroApellido2,
            terceroMail,
            terceroTel,
            terceroCel,
            terceroDireccion,
            terceroPassword,
            terceroPasswordConfirm,

        } = this.props.form;

        const {onChange, onSubmit, loadData, agreePP, agreeTD, aceptaPP, aceptaTD} = this.props;

        return (
            <div>
                <form onSubmit={onSubmit}>
                    <Grid
                        container
                        direction="column"
                        justify="flex-start"
                        alignItems="center">

                        <Card className='container-login'>

                            <Avatar style={{background: Colors.accent, marginLeft: '45%'}}>
                                <PersonAddIcon/>
                            </Avatar>

                            <CardHeader title="Regístrate"/>

                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <FormControl required variant="outlined" style={{width: '100%'}}>
                                        <InputLabel id="demo-simple-select-outlined-label">Tipo Documento</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-outlined-label"
                                            id={documentoTipoID.key}
                                            name={documentoTipoID.key}
                                            value={documentoTipoID.value}
                                            onChange={onChange}
                                            label="Tipo Documento"
                                            required={documentoTipoID.required}
                                            variant='outlined'
                                        >

                                            {loadData.documentTypes.map((val, index) => {
                                                return (
                                                    <MenuItem key={index}
                                                              value={val.documentoTipoID}>{val.documentoTipoDescripcion}</MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <AppInputNumber
                                        id={terceroDocumento.key}
                                        name={terceroDocumento.key}
                                        value={terceroDocumento.value}
                                        label='Número de documento'
                                        onChange={onChange}
                                        required={terceroDocumento.required}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <AppInputText
                                        id={terceroNombre1.key}
                                        name={terceroNombre1.key}
                                        value={terceroNombre1.value}
                                        label='Primer Nombre'
                                        onChange={onChange}
                                        required={terceroNombre1.required}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <AppInputText
                                        id={terceroNombre2.key}
                                        name={terceroNombre2.key}
                                        value={terceroNombre2.value}
                                        label='Segundo Nombre'
                                        onChange={onChange}
                                        required={terceroNombre2.required}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <AppInputText
                                        id={terceroApellido1.key}
                                        name={terceroApellido1.key}
                                        value={terceroApellido1.value}
                                        label='Primer Apellido'
                                        onChange={onChange}
                                        required={terceroApellido1.required}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <AppInputText
                                        id={terceroApellido2.key}
                                        name={terceroApellido2.key}
                                        value={terceroApellido2.value}
                                        label='Segundo Apellido'
                                        onChange={onChange}
                                        required={terceroApellido2.required}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <AppInputText
                                        id={terceroMail.key}
                                        name={terceroMail.key}
                                        value={terceroMail.value}
                                        label='Email'
                                        onChange={onChange}
                                        required={terceroMail.required}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <AppInputTel
                                        id={terceroTel.key}
                                        name={terceroTel.key}
                                        value={terceroTel.value}
                                        label='Teléfono'
                                        onChange={onChange}
                                        required={terceroTel.required}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <AppInputCel
                                        id={terceroCel.key}
                                        name={terceroCel.key}
                                        value={terceroCel.value}
                                        label='Celular'
                                        onChange={onChange}
                                        required={terceroCel.required}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <AppInputText
                                        id={terceroDireccion.key}
                                        name={terceroDireccion.key}
                                        value={terceroDireccion.value}
                                        label='Dirección'
                                        onChange={onChange}
                                        required={terceroDireccion.required}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>

                                    <AppInputPasswordView
                                        id={terceroPassword.key}
                                        name={terceroPassword.key}
                                        value={terceroPassword.value}
                                        label='Contraseña'
                                        onChange={onChange}
                                        required={terceroPassword.required}
                                        labelWidth={100}
                                    />

                                </Grid>
                                <Grid item xs={12} sm={6}>

                                    <AppInputPasswordView
                                        id={terceroPasswordConfirm.key}
                                        name={terceroPasswordConfirm.key}
                                        value={terceroPasswordConfirm.value}
                                        label='Repita la contraseña'
                                        onChange={onChange}
                                        required={terceroPasswordConfirm.required}
                                        labelWidth={170}
                                    />

                                </Grid>

                                <Grid item xs={12}>
                                    <Alert severity="info">
                                        La contraseña debe ser de ocho caracteres mínimo, contener una letra en
                                        mayúscula y un número.
                                    </Alert>
                                    <p style={{fontStyle: 'italic'}}>Los campos marcados con (*) son obligatorios.</p>
                                </Grid>

                                <Grid item xs={12} style={{textAlign: 'left'}}>
                                    <FormControlLabel
                                        control={<Checkbox readOnly={true} checked={aceptaPP}/>}
                                        label={
                                            <span style={{fontSize: '.8rem'}}> Acepto la
                                                <span style={{cursor: 'pointer', color: '#1976d2'}}
                                                      onClick={this.handleOpenModal}> Política de Privacidad
                                                </span>
                                            </span>}
                                    />
                                </Grid>

                                <Grid item xs={12} style={{textAlign: 'left'}}>
                                    <FormControlLabel
                                        control={<Checkbox readOnly={true} checked={aceptaTD}/>}
                                        label={
                                            <span style={{fontSize: '.8rem'}}>
                                                Acepto que mis datos sean tratados conforme a la política de tratamiento de
                                                datos de Electrohuila S.A. - E.S.P. ...
                                                <span style={{cursor: 'pointer', color: '#1976d2'}}
                                                      onClick={this.handleOpenModalTD}> Más información
                                                </span>
                                            </span>}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <AppButton
                                        type='submit'
                                        label='Registrarme'
                                        size='large'
                                    />
                                </Grid>
                                <Grid item xs={12} style={{padding: '15px'}}>
                                    <Link to='/' variant="body2">
                                        {"Volver"}
                                    </Link>
                                </Grid>
                            </Grid>
                        </Card>
                    </Grid>
                </form>

                <AlertPrivacyPolicy
                    executeAPI={false}
                    updateAgreePP={agreePP}
                    openModal={this.state.openModal}
                    onCloseModal={this.handleCloseModal}
                />

                <AlertDataTreatment
                    executeAPI={false}
                    updateAgreeTD={agreeTD}
                    openModal={this.state.openModalTD}
                    onCloseModal={this.handleCloseModalTD}
                />

            </div>
        );
    }

}

export default SignupForm

